import cms from './common/cms'
export default {
  mixins: [cms],
  methods: {
    async getFaviconIcon() {}
  }
}
